// цвета для операндов
export const COLORED: string = '#ff0000'
export const COLORGREEN: string = '#00ff0c'
